import styled from "styled-components"

export const List = styled.ul`
  padding-left: 18px;
`

export const ListItem = styled.li`
  color: ${({ theme }) => theme.colors.darkGrey};
  line-height: 1.55em;
`
